import HeadLayout from "@shared/layouts/HeadLayout";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

const UsersPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <HeadLayout title={t("navigation.users")}></HeadLayout>
      <Outlet />
    </>
  );
};

export default UsersPage;
8;
